import React from 'react';
import styles from './AddProgramsHeader.module.scss';
import nextIcon from '../../../assets/Imagess/next.svg';
import floppyIcon from '../../../assets/Imagess/floppy.svg';
import Buttons from '../../Atoms/Buttons/Buttons';
import { transform } from 'lodash';

const AddProgramsHeader = ({ step, handleNextClick, mode }) => {
  return (
    <div className={styles['add-programs-header']}>
      <div>
        <p className={styles['title']}>
          {mode === 'add' ? 'إنشاء برنامج جديد ' : 'تعديل البرنامج'}
        </p>
      </div>
      <div className={styles['icon-subcontainer']}>
        <Buttons
          text={step !== 3 ? 'التالي' : 'إنهاء'}
          icon={nextIcon}
          rounded={true}
          color="rgba(13, 160, 110, 1)"
          handleOnClick={handleNextClick}
          style={{ fontFamily: 'BukraMedium' }}
          iconStyle={{transform:"rotate(180deg)"}}
        />
      </div>
    </div>
  );
};

export default AddProgramsHeader;
